export default __webpack_public_path__ + "static/media/google-paly-app-saludsa.f68d93c9.svg";